
export default {
  install(editor) {
    let latestId = 0;

    editor.on('import', ({ nodes }) => {
      latestId = Math.max(0, ...Object.keys(nodes));
    });

    editor.on('nodecreate', node => {
      if (editor.silent) return; // when importing

      // eslint-disable-next-line no-param-reassign, no-plusplus
      node.id = ++latestId;
    });
  },
};
